<template>
  <div class="container">
    <div class="row">
      <div class="small-12 columns text-center">
        <router-link to="/"><img src="../../assets/logo-med.png" class="logo" alt="" /></router-link>
      </div>
    </div>
    <div class="row">
      <div class="small-3 columns small-centered text-center">
        <p><br>Hozzáférés engedélyezéséhez lépjen kapcsolatba az üzemeltetőkkel.</p>
      </div>
    </div>
    <div class="row">
      <div class="small-3 columns small-centered">
        <error-callout :error="error"></error-callout>
      </div>
    </div>
  </div>
</template>

<script>
import ErrorCallout from '../errors/Callout'

export default {
  name: 'preregistered',
  components: {
    ErrorCallout
  },
  data () {
    return {
      error: null
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '../../sass/foundation-import';
  @import '../../sass/layouts/form';

  .container {
    margin: 0 0 $global-margin*3 0;
  }

  img.logo {
    margin: rem-calc(40) 0 0 0;
  }

  img.phones {
    margin: rem-calc(20) 0;
  }

  .button {
    width: 100%;
    margin: $global-margin/3 0 $global-margin/3 0;
  }

  p {
    margin: 0 0 $global-margin*3 0;
  }

  .callout.error {
    margin-top: $global-margin / 3;
  }
</style>



// WEBPACK FOOTER //
// Preregistered.vue?a60eb9b2